var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 265,
    viewBox: "0 0 191 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.54 81.3634C173.763 52.4947 148.844 42.8201 117.354 40.0609V0H92.9865V38.9916C86.5885 38.9916 80.0353 39.1124 73.5338 39.2503V0H49.1662L49.149 40.0264C43.8719 40.1298 38.6811 40.2333 33.6283 40.2333V40.1126L0.0172516 40.0954V66.1358C0.0172516 66.1358 18.0213 65.7909 17.7109 66.1185C27.5924 66.1185 30.8 71.844 31.7313 76.7934V122.424C32.4211 122.424 33.3006 122.459 34.3008 122.597H31.7313L31.714 186.525C31.2829 189.629 29.4549 194.579 22.5568 194.596C22.8672 194.872 4.84592 194.596 4.84592 194.596L0 223.706H31.7313C37.6292 223.706 43.4408 223.81 49.1318 223.844L49.149 264.353H73.4993V224.275C80.1732 224.413 86.6402 224.465 92.9692 224.465L92.952 264.353H117.32V223.93C158.294 221.585 187.008 211.255 190.56 172.764C193.44 141.774 178.868 127.926 155.604 122.338C169.762 115.164 178.609 102.489 176.54 81.3634V81.3634ZM142.429 167.969C142.429 198.235 90.6066 194.803 74.0684 194.803V141.118C90.6066 141.153 142.429 136.41 142.429 167.969V167.969ZM131.081 92.2452C131.081 119.786 87.8301 116.561 74.0684 116.578V67.912C87.8474 67.912 131.098 63.5317 131.081 92.2452Z",
    fill: "#212121",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7874 121.349H35.4089V124.022H31.7874V121.349Z",
    fill: "#212121",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcoin);
export default __webpack_public_path__ + "static/media/btcoin.b15696b6.svg";
export { ForwardRef as ReactComponent };